import { render } from "./TrainerSessionCard3.vue?vue&type=template&id=0fa297dc&scoped=true"
import script from "./TrainerSessionCard3.vue?vue&type=script&lang=js"
export * from "./TrainerSessionCard3.vue?vue&type=script&lang=js"

import "./TrainerSessionCard3.vue?vue&type=style&index=0&id=0fa297dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa297dc"]])

export default __exports__